const DefaultModule = (props) => {
  console.log(
    `HELLO DEVELOPER! Component - ${props.definitionName} not defined`
  );
  return null;
};

export default DefaultModule;
